import React from 'react';

export const useScrollDirection = () => {
  const y = React.useRef(0);
  const scrollDirection = React.useRef<'up' | 'down' | null>(null);
  React.useEffect(() => {
    y.current = window.scrollY;
    const handleScroll = (e: Event) => {
      const window = e.currentTarget as Window;
      if (y.current > window.scrollY) {
        scrollDirection.current = 'up';
      } else if (y.current < window.scrollY) {
        scrollDirection.current = 'down';
      }
      y.current = window.scrollY;
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return scrollDirection;
};
